import axios from 'axios'

// Same-origin API; the Better Auth session cookie rides along automatically.
export const api = axios.create({ baseURL: '', withCredentials: true })

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname.startsWith('/app')) {
      const back = encodeURIComponent(window.location.pathname + window.location.search)
      window.location.assign(`/login?next=${back}`)
    }
    return Promise.reject(err)
  },
)

export const get = (url, params) => api.get(url, { params }).then((r) => r.data)
export const post = (url, body) => api.post(url, body).then((r) => r.data)
export const put = (url, body) => api.put(url, body).then((r) => r.data)
export const patch = (url, body) => api.patch(url, body).then((r) => r.data)
/** `body` goes in the request body (axios needs `data` for DELETE), e.g. a typed confirmation. */
export const del = (url, body) => api.delete(url, body ? { data: body } : undefined).then((r) => r.data)

/** Human-readable error from an axios failure (API returns {error, details}). */
export function errorMessage(e, fallback = 'Something went wrong') {
  const d = e?.response?.data
  if (d?.details && Array.isArray(d.details)) return `${d.error}: ${d.details.join('; ')}`
  return d?.error || d?.message || e?.message || fallback
}
